import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { SfEditor } from '../../custom/custom';
var FormulaUtils = /*#__PURE__*/function () {
  function FormulaUtils(editor) {
    _classCallCheck(this, FormulaUtils);
    this.editor = editor;
  }
  _createClass(FormulaUtils, [{
    key: "isFormulaActive",
    value: function isFormulaActive() {
      var nodes = SfEditor.match(this.editor, this.editor.selection, {
        type: 'formula'
      });
      if (nodes) {
        return true;
      }
      return false;
    }
  }, {
    key: "insertFormula",
    value: function insertFormula(data) {
      SfEditor.insertNodes(this.editor, {
        type: 'formula',
        children: [{
          text: ''
        }],
        data: data
      }, {
        at: data.at,
        void: true
      });
    }
  }, {
    key: "setFormula",
    value: function setFormula(data) {
      var formula = data.formula,
        at = data.at;
      SfEditor.setNodes(this.editor, {
        data: {
          formula: formula
        }
      }, {
        at: at,
        void: true
      });
    }
  }]);
  return FormulaUtils;
}();
export default FormulaUtils;